/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({
/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
/* harmony export */ __webpack_require__.d(__webpack_exports__, { A: () => (/* binding */ GlobalDrawer) });
class GlobalDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll('[data-drawer-close]');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeAllDrawers = this.closeAllDrawers.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.lastFocusedElement = null;
  }
  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-drawer'});
    window.eventBus.on('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => element.addEventListener('click', this.closeDrawer));
    this.addEventListener('keydown', this.handleKeydown);
    if (window.Shopify.designMode) window.addEventListener('resize', this.handleResize);
  }
  openDrawer() {
    this.lastFocusedElement = document.activeElement;
    window.eventBus.emit('close:all:drawers', this);
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-drawer-open');
    this.addEventListener('transitionend', this.handleTransitionEnd);
    window.eventBus.emit('drawer:opened', this);
  }
  closeDrawer() {
    const wasOpen = this.getAttribute('aria-hidden') === 'false';
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-drawer-open');
    this.removeEventListener('transitionend', this.handleTransitionEnd);
    window.eventBus.emit('drawer:closed', this);
    if (wasOpen && this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
      this.lastFocusedElement.focus();
    }
  }
  closeAllDrawers(e) { if (e === this) return; this.closeDrawer(); }
  handleTransitionEnd(e) { if (e.target === this) this.trapFocus(); }
  handleKeydown(e) {
    if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
      e.preventDefault();
      this.closeDrawer();
      return;
    }
    if (e.key !== 'Tab' || this.getAttribute('aria-hidden') !== 'false') return;
    const focusableElements = Array.from(this.querySelectorAll('button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => el.offsetParent !== null);
    if (!focusableElements.length) return;
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    if (e.shiftKey && document.activeElement === firstFocusableElement) { lastFocusableElement.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === lastFocusableElement) { firstFocusableElement.focus(); e.preventDefault(); }
  }
  trapFocus() {
    const focusableElements = Array.from(this.querySelectorAll('button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => el.offsetParent !== null);
    if (focusableElements.length) focusableElements[0].focus();
  }
  handleResize() { this.classList.add('disable-transitions'); setTimeout(() => this.classList.remove('disable-transitions'), 500); }
  disconnectedCallback() {
    this.removeEventListener('keydown', this.handleKeydown);
    if (window.Shopify.designMode) window.removeEventListener('resize', this.handleResize);
  }
}
/***/ })
/******/ 	});
/******/ 	var __webpack_module_cache__ = {};
/******/ 	function __webpack_require__(moduleId) { var cachedModule = __webpack_module_cache__[moduleId]; if (cachedModule !== undefined) return cachedModule.exports; var module = __webpack_module_cache__[moduleId] = { exports: {} }; __webpack_modules__[moduleId](module, module.exports, __webpack_require__); return module.exports; }
/******/ 	(() => { __webpack_require__.d = (exports, definition) => { for(var key in definition) { if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) Object.defineProperty(exports, key, { enumerable: true, get: definition[key] }); } }; })();
/******/ 	(() => { __webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop)) })();
var __webpack_exports__ = {};
/* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5669);
class CartDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__.A {
  constructor() {
    super();
    this.dynamicContentIds = ['cart-header','cart-body','cart-footer'];
    this.scrollElement = this.querySelector('[data-cart-scroll-element]');
    this.handleCartOpen = this.handleCartOpen.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleCartRender = this.handleCartRender.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-drawer'});
    window.eventBus.on('open:cart:drawer', this.handleCartOpen);
    window.eventBus.on('update:cart:drawer', this.handleCartUpdate);
    window.eventBus.on('render:cart:drawer', this.handleCartRender);
  }
  handleCartOpen(e) { if (e?.scrollToTop && this.scrollElement) this.scrollElement.scrollTo(0,0); this.openDrawer(); }
  handleCartUpdate(e) { if (!e) return; if (e.sections?.['cart-drawer']) this.renderCartDrawer(e.sections['cart-drawer']); }
  renderCartDrawer(html) {
    this.dynamicContentIds.forEach((id) => {
      const selector = `[data-cart-dynamic-content="${id}"]`;
      const updatedContent = this.getContent(html, selector);
      const targetElement = this.querySelector(selector);
      if (targetElement && updatedContent !== undefined) targetElement.innerHTML = updatedContent || '';
    });
    this.scrollElement = this.querySelector('[data-cart-scroll-element]');
    if (this.getAttribute('aria-hidden') === 'false') this.trapFocus();
  }
  async handleCartRender() {
    try {
      const response = await fetch(window.Shopify.routes.root + "?sections=cart-drawer");
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const responseJson = await response.json();
      if (responseJson?.['cart-drawer']) this.renderCartDrawer(responseJson['cart-drawer']);
    } catch (error) { console.error('Failed to fetch cart drawer:', error); }
  }
  getContent(html, selector) { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML; }
}
customElements.define('cart-drawer', CartDrawer);
/******/ })();
